  <div class="db-recharge">
    <div class="db-recharge__header">Payment<span class="db-label-red ml8">Failed</span></div>
    <div class="db-recharge__message">
      <p [innerHTML]="(userSubscription?.plan.type === UserSubscriptionType.ONE_PRODUCT ? 'text_rechargePaymentFailedDesc2' : 'text_rechargePaymentFailedDesc1') | dbText"></p>
    </div>
    <div class="db-recharge__button">
      <a class="ds-btn ds-btn-black" (click)="renewUserSubscription(true)">
        <span>{{'text_retry' | dbText}}</span>
      </a>
    </div>
  </div>
